import groupBy from '../lib/groupBy.js';

const filterUnreportedGroups = (data) => {
  return data.filter((n) => !n.name.toLowerCase().includes('not reported'));
};

const formatData = ({ statsResponse, keywordsResponse, groupsResponse }) => {
  const groupData = filterUnreportedGroups(groupsResponse.data);

  const parsedData = (statsResponse.data || []).map((region) => {
    const keywords = (region.keywords || []).map((n) => ({
      ...n,
      ...(keywordsResponse.data || []).find((o) => !!n.id && o.id === n.id),
    }));
    const groups = Object.entries(groupBy(keywords, 'group_id'))
      .map(([key, value]) => ({ id: key, keywords: value }))
      .map((n) => ({
        ...n,
        ...groupData.find((o) => !!o.id && o.id === n.id),
      }));
    return {
      region: region.region_name,
      seID: region.seID,
      groups,
    };
  });

  const sortedParsedData = parsedData.map((group) => {
    let sortedGroups = group.groups.map((item) => {
      //reverse array
      item.keywords.forEach((item, index) => {
        let bucket = {};
        let updatedPositions = [];

        item.positions.forEach((item, index) => {
          let date_array = item.date.split('-');
          let key = parseInt(date_array[0], 10) + (parseInt(date_array[1], 10) + '').padEnd(2, '0');
          bucket[key] ? bucket[key].push(item) : (bucket[key] = [item]);
        });
        for (let n of Object.entries(bucket)) {
          updatedPositions.push(...n[1]);
        }

        item.positions = updatedPositions;
      });

      let sortedKeywords = item.keywords.sort((a, b) => {
        /*
         * If the position is equal to 0, overwrite to 100
         * */

        if (a.positions[a.positions.length - 1].pos === 0) {
          a.positions[a.positions.length - 1].pos = 100;
        }
        if (b.positions[b.positions.length - 1].pos === 0) {
          b.positions[b.positions.length - 1].pos = 100;
        }
        return a.positions[a.positions.length - 1].pos - b.positions[b.positions.length - 1].pos;
      });

      const index = sortedKeywords.findIndex((keyword) => {
        return keyword.positions[keyword.positions.length - 1].pos !== '0';
      });

      if (index > 0) {
        sortedKeywords = [...sortedKeywords.splice(index), ...sortedKeywords.splice(0, index)];
      }

      return {
        ...item,
        keywords: sortedKeywords,
      };
    });

    const index = sortedGroups.findIndex((item) => {
      if (item.name) {
        return item.name.toLowerCase().includes('priority');
      }
      return 0;
    });

    sortedGroups = index > 0 ? [sortedGroups[index], ...sortedGroups.slice(0, index), ...sortedGroups.slice(index + 1)] : sortedGroups;

    sortedGroups = sortedGroups.filter((group) => group.name);

    return {
      ...group,
      groups: sortedGroups,
    };
  });
  return sortedParsedData;
};
const determineReduxStateFromUrl = (arr) => {
  const STATS = 'stats';
  const KEYWORDS = 'keywords';
  const GROUPS = 'groups';
  const data = { statsResponse: [], keywordsResponse: [], groupsResponse: [] };
  arr.forEach((item) => {
    if (item.config.url.includes(STATS)) {
      data.statsResponse = item;
    }
    if (item.config.url.includes(KEYWORDS)) {
      data.keywordsResponse = item;
    }
    if (item.config.url.includes(GROUPS)) {
      data.groupsResponse = item;
    }
  });
  return data;
};

export const crm_rankings_middleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    if (action.type === 'FETCH_CRM_RANKINGS_DATA_SUCCESS') {
      let obj = determineReduxStateFromUrl(action.payload);
      const formattedData = formatData(obj);
      action.payload = (formattedData || []).filter((n) => (n.groups || []).length);
    }
    next(action);
  };
